import Layout from './Layout/Layout.vue'
import WidgetCard from './WidgetCard/WidgetCard.vue'

export default {
    Layout,
    WidgetCard,
}
